import * as React from "react";
import type { SVGProps } from "react";
const SvgBackpack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.879 10.879A3 3 0 0 1 9 10h6a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-4a3 3 0 0 1 .879-2.121m1.414 6.828A1 1 0 0 0 9 18h6a1 1 0 0 0 1-1v-1H8v1a1 1 0 0 0 .293.707M16 14v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4v1a9 9 0 0 1 5 8v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7a9 9 0 0 1 5-8V4a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3m-5.707-.707A1 1 0 0 0 10 4h4a1 1 0 0 0-1-1h-2a1 1 0 0 0-.707.293m8.414 17.414A1 1 0 0 0 19 20v-7a7 7 0 0 0-14 0v7a1 1 0 0 0 1 1h12a1 1 0 0 0 .707-.293"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBackpack;
